import { MessageToastTheme, variants } from '../MessageToastStyles.css';
import { baseTheme } from './MessageToastBaseTheme.css';
import { multiVariantStyles } from './MessageToastVariants.css';

/*******************
 * Component Theme
 *******************/

const MessageToastStableTheme: MessageToastTheme = {
  baseTheme,
  multiVariantStyles,
  variants
};

/*******************
 * Exports
 *******************/

export { MessageToastStableTheme };
